import { Link } from 'react-router';
import { pageRoutes } from '../routes/page-routes';

export function NotFoundPage() {
  return (
    <main className="grid gap-3 p-8 text-center text-muted">
      <h1 className="text-2xl font-bold text-ink">Page not found</h1>
      <p>
        <Link className="font-semibold text-primary underline" to={pageRoutes.dashboard}>
          Back to the dashboard
        </Link>
      </p>
    </main>
  );
}
